<template>
    <div class="page-card">
        <router-link :to="{name: 'cards'}" class="btn-back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_829_33681)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8.00025C16 8.26544 15.8947 8.51976 15.7071 8.70728C15.5196 8.8948 15.2653 9.00014 15.0001 9.00014L3.4154 9.00014L7.70893 13.2917C7.89668 13.4794 8.00216 13.7341 8.00216 13.9996C8.00216 14.2651 7.89668 14.5198 7.70893 14.7075C7.52117 14.8953 7.26653 15.0007 7.00101 15.0007C6.73548 15.0007 6.48084 14.8953 6.29308 14.7075L0.293754 8.70818C0.200638 8.61529 0.126761 8.50496 0.0763534 8.38348C0.025946 8.262 -6.00504e-07 8.13177 -6.12001e-07 8.00025C-6.23499e-07 7.86873 0.025946 7.73851 0.0763534 7.61703C0.126761 7.49555 0.200638 7.38521 0.293754 7.29233L6.29308 1.293C6.48084 1.10525 6.73548 0.999775 7.001 0.999775C7.26653 0.999775 7.52117 1.10525 7.70893 1.293C7.89668 1.48076 8.00216 1.7354 8.00216 2.00093C8.00216 2.26645 7.89668 2.52109 7.70893 2.70885L3.4154 7.00037L15.0001 7.00037C15.2653 7.00037 15.5196 7.10571 15.7071 7.29322C15.8947 7.48074 16 7.73507 16 8.00025Z" fill="currentColor"/>
                </g>
                <defs>
                    <clipPath id="clip0_829_33681">
                        <rect width="16" height="15.9982" fill="white" transform="translate(16 15.999) rotate(180)"/>
                    </clipPath>
                </defs>
            </svg>

            <span>{{__('web_btn_back_to_cards')}}</span>
        </router-link>

        <div v-if="card_info" class="card-info">

            <p class="block-status">{{__('web_item_card_status_active')}}</p>
<!--            <p class="block-status">{{__('web_item_card_status_inactive')}}</p>-->

            <div class="block-card">
                <p class="block-card__number" v-if="isCopy">{{__('web_text_copied')}}</p>

                <p v-else-if="show_number" v-on:click="copyNumber" class="block-card__number">{{card_info.number.slice(0, 4) + ' ' + card_info.number.slice(4, 8) + ' ' + card_info.number.slice(8, 12) + ' ' + card_info.number.slice(-4)}}</p>

                <p v-else v-on:click="copyNumber" class="block-card__number">{{card_info.number.slice(0, 4) + ' •••• ' + '•••• ' + card_info.number.slice(-4)}}</p>

                <div class="block-card__info">
                    <p>Trent Alexander-Arnold</p>
                    <span>06 / 25</span>
                </div>
            </div>

            <div class="block-info">
                <p class="block-name">VISA Virtual card</p>

                <p class="block-balance">{{user.course_current.course_marker}} {{$primNum('999' * user.course_current.course_current)}}</p>

                <div class="block-cvv" v-on:click="show_cvv = true">
                    <span class="block-cvv__title">CVV</span>
                    <p v-if="show_cvv" class="block-cvv__text">123</p>
                    <p v-else class="block-cvv__text">***</p>
                </div>

                <div class="block-buttons">
                    <div class="block-buttons__left">
                        <router-link :to="user.google_2fa ? {name: 'deposit'} : {name: 'setting', params: {'isTwoFa': true}}" class="btn-deposit">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8337 5.34175L14.6587 4.16675L5.83366 12.9917L5.83366 7.50008H4.16699L4.16699 15.8334L12.5003 15.8334V14.1667L7.00866 14.1667L15.8337 5.34175Z" fill="#01AA4F"/>
                            </svg>

                            {{__('web_btn_top_up')}}
                        </router-link>

                        <router-link :to="user.google_2fa ? {name: 'withdraw'} : {name: 'setting', params: {'isTwoFa': true}}" class="btn-withdraw">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.16634 14.6583L5.34134 15.8333L14.1663 7.00825L14.1663 12.4999L15.833 12.4999L15.833 4.16659L7.49968 4.16659L7.49968 5.83325L12.9913 5.83325L4.16634 14.6583Z" fill="#F51E38"/>
                            </svg>

                            {{__('web_btn_withdraw')}}
                        </router-link>
                    </div>

                    <div class="btn-settings">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1329_76504)">
                                <path d="M14.4712 8.43552V7.55875L15.6012 6.59603C15.8095 6.41726 15.9462 6.17256 15.9871 5.90516C16.0281 5.63776 15.9706 5.36488 15.8249 5.13475L14.4358 2.84254C14.3326 2.66849 14.1842 2.52392 14.0055 2.42333C13.8268 2.32275 13.6241 2.2697 13.4176 2.26949C13.2897 2.26854 13.1625 2.28789 13.0409 2.3268L11.6107 2.7967C11.3638 2.63694 11.1062 2.49336 10.8397 2.36691L10.5395 0.922822C10.4857 0.658993 10.3383 0.421999 10.1231 0.253328C9.90791 0.0846577 9.63863 -0.00494324 9.36241 0.000210557H6.60793C6.33171 -0.00494324 6.06243 0.0846577 5.84723 0.253328C5.63203 0.421999 5.48462 0.658993 5.43079 0.922822L5.13063 2.36691C4.8622 2.49333 4.60266 2.6369 4.35372 2.7967L2.95293 2.30388C2.8301 2.27271 2.70289 2.2611 2.57625 2.26949C2.36983 2.2697 2.16709 2.32275 1.98837 2.42333C1.80965 2.52392 1.66124 2.66849 1.55803 2.84254L0.169016 5.13475C0.0316375 5.36453 -0.0194119 5.63368 0.0246114 5.89608C0.0686347 6.15848 0.204991 6.39782 0.410328 6.5731L1.52272 7.56448V8.44125L0.410328 9.40398C0.199191 9.58047 0.0591049 9.8241 0.0149291 10.0916C-0.0292468 10.3591 0.0253451 10.6332 0.169016 10.8653L1.55803 13.1575C1.66124 13.3315 1.80965 13.4761 1.98837 13.5767C2.16709 13.6772 2.36983 13.7303 2.57625 13.7305C2.70417 13.7315 2.8314 13.7121 2.95293 13.6732L4.38315 13.2033C4.63007 13.3631 4.88765 13.5066 5.15417 13.6331L5.45434 15.0772C5.50816 15.341 5.65557 15.578 5.87077 15.7467C6.08598 15.9153 6.35525 16.0049 6.63147 15.9998H9.4095C9.68571 16.0049 9.95499 15.9153 10.1702 15.7467C10.3854 15.578 10.5328 15.341 10.5866 15.0772L10.8868 13.6331C11.1552 13.5067 11.4148 13.3631 11.6637 13.2033L13.088 13.6732C13.2096 13.7121 13.3368 13.7315 13.4647 13.7305C13.6711 13.7303 13.8739 13.6772 14.0526 13.5767C14.2313 13.4761 14.3797 13.3315 14.4829 13.1575L15.8249 10.8653C15.9622 10.6355 16.0133 10.3663 15.9693 10.1039C15.9252 9.84152 15.7889 9.60218 15.5836 9.4269L14.4712 8.43552ZM13.4176 12.5844L11.3989 11.9197C10.9263 12.3094 10.3862 12.6141 9.80384 12.8194L9.38596 14.8766H6.60793L6.19004 12.8423C5.61232 12.6312 5.07513 12.327 4.60092 11.9426L2.57625 12.5844L1.18723 10.2922L2.78813 8.91688C2.67931 8.32369 2.67931 7.71642 2.78813 7.12323L1.18723 5.7078L2.57625 3.41559L4.59503 4.08033C5.06761 3.6906 5.60772 3.38594 6.19004 3.18064L6.60793 1.12339H9.38596L9.80384 3.15772C10.3816 3.36885 10.9187 3.67298 11.393 4.05741L13.4176 3.41559L14.8066 5.7078L13.2057 7.08312C13.3146 7.67631 13.3146 8.28358 13.2057 8.87677L14.8066 10.2922L13.4176 12.5844Z" fill="currentColor"/>
                                <path d="M8 11.75C7.25832 11.75 6.5333 11.5301 5.91661 11.118C5.29993 10.706 4.81928 10.1203 4.53545 9.43506C4.25162 8.74984 4.17736 7.99584 4.32206 7.26841C4.46675 6.54098 4.8239 5.8728 5.34835 5.34835C5.8728 4.8239 6.54098 4.46675 7.26841 4.32206C7.99584 4.17736 8.74984 4.25162 9.43506 4.53545C10.1203 4.81928 10.706 5.29993 11.118 5.91661C11.5301 6.5333 11.75 7.25832 11.75 8C11.755 8.49385 11.6614 8.98374 11.4748 9.44098C11.2881 9.89821 11.0121 10.3136 10.6628 10.6628C10.3136 11.0121 9.89821 11.2881 9.44098 11.4748C8.98374 11.6614 8.49385 11.755 8 11.75ZM8 5.5C7.66959 5.4923 7.34105 5.55171 7.03426 5.67462C6.72747 5.79753 6.44879 5.9814 6.2151 6.2151C5.9814 6.44879 5.79753 6.72747 5.67462 7.03426C5.55171 7.34105 5.4923 7.66959 5.5 8C5.4923 8.33041 5.55171 8.65895 5.67462 8.96574C5.79753 9.27253 5.9814 9.55121 6.2151 9.78491C6.44879 10.0186 6.72747 10.2025 7.03426 10.3254C7.34105 10.4483 7.66959 10.5077 8 10.5C8.33041 10.5077 8.65895 10.4483 8.96574 10.3254C9.27253 10.2025 9.55121 10.0186 9.78491 9.78491C10.0186 9.55121 10.2025 9.27253 10.3254 8.96574C10.4483 8.65895 10.5077 8.33041 10.5 8C10.5077 7.66959 10.4483 7.34105 10.3254 7.03426C10.2025 6.72747 10.0186 6.44879 9.78491 6.2151C9.55121 5.9814 9.27253 5.79753 8.96574 5.67462C8.65895 5.55171 8.33041 5.4923 8 5.5Z" fill="currentColor"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1329_76504">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>

                        <span>{{__('web_btn_card_settings')}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="history" class="block-history">
            <div class="block-head">
                <div class="block-head__left">
                    <p class="head-title">{{__('web_page_home_business_block_operations_title')}}</p>
                </div>

                <div class="block-head__right">

                </div>
            </div>

            <div class="block-aside">
                <p class="block-aside__date">{{__('web_page_transaction_history_Time')}}</p>
                <p class="block-aside__sum">{{__('web_page_transaction_history_Sum')}}</p>
                <p class="block-aside__desc">{{__('web_page_transaction_history_description')}}</p>
                <p class="block-aside__status">{{__('web_page_transaction_history_Status')}}</p>
            </div>


            <div v-if="history.data.length" class="list-wrapper">
                <ItemHistoryCard
                    v-for="(item, key) in history.data"
                    :key="key"
                    v-bind:history="history.data"
                    v-bind:index="key"
                    v-bind:item="item"
                    v-bind:table="table"
                ></ItemHistoryCard>
            </div>

            <div class="block-no-result" v-else-if="!history.data.length">
                <svg width="100" height="100" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M80 146.667H113.333C133.333 146.667 146.667 133.333 146.667 113.333V79.9998C146.667 61.9998 135.333 48.6665 118.667 46.6665C117.333 46.6665 115.333 46.6665 113.333 46.6665H46.6667C44.6667 46.6665 43.3334 46.6663 41.3334 47.333C24 49.333 13.3334 61.9998 13.3334 79.9998C13.3334 81.9998 13.3334 84.6665 13.3334 86.6665" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path opacity="0.4" d="M113.328 46.6681H46.6615C44.6615 46.6681 43.3281 46.668 41.3281 47.3346C41.9948 45.3346 43.3282 44.0014 45.3282 42.0014L66.6615 20.0015C75.9948 10.6681 90.6615 10.6681 99.9948 20.0015L111.995 32.0014C115.995 36.0014 117.995 41.3348 118.661 46.6681C117.328 46.6681 115.328 46.6681 113.328 46.6681Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path opacity="0.4" d="M146.667 83.3335H126.667C119.333 83.3335 113.333 89.3335 113.333 96.6668C113.333 104 119.333 110 126.667 110H146.667" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M59.9974 121.333C59.9974 109.533 50.4641 100 38.6641 100C26.8641 100 17.3307 109.533 17.3307 121.333C17.3307 133.133 26.8641 142.667 38.6641 142.667C50.4641 142.667 59.9974 133.133 59.9974 121.333Z" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.3334 146.667L20 140" stroke="#DADADA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <p class="block-no-result__text">{{__('web_wallets_No result')}}</p>
            </div>

            <div v-else class="block-loading">
                <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                <p class="block-loading__text">{{__('Loading')}}</p>
            </div>
        </div>

        <div v-else class="block-loading">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            <p class="block-loading__text">{{__('Loading')}}</p>
        </div>
    </div>
</template>

<script>
    // import DotLoader from 'vue-spinner/src/DotLoader.vue';
    import ItemHistoryCard from "./ItemHistoryCard";

    export default {
        name: 'PageCard',
        data: function() {
            return {
                card_info: {
                    number: '2345678945671234',
                    id: 1,
                },
                show_cvv: false,
                show_number: false,
                isCopy: false,

                history: null,
                table: null,
                modal_info: null,
            }
        },
        watch: {

        },
        computed: {
            user() {
                return this.$store.getters.user
            },
            wallets() {
                return this.$store.getters.wallets
            }
        },
        created() {
            this.$http.get('ajax/store/history')
                .then(response=> {
                    return response.json()
                })
                .then((response)=> {
                    response = response.data;

                    this.history = response.history;
                    this.table = response.table;
                }).catch((err) => {
                this.httpHandler(err);
            });
        },

        methods: {
            copyNumber() {
                this.isCopy = true;
                this.show_number = true;
                this.$copyMessage(this.card_info.number);
                setTimeout(()=> {
                    this.isCopy = false;
                }, 2000);
            },
        },
        components: {
            // DotLoader,
            ItemHistoryCard
        }
    }
</script>
